import { State } from 'src/types'
import { webTop, webBottom } from 'src/features/dxm/drawer/rightThrow/firstmitt/back/web'
import { catchFace } from 'src/features/dxm/drawer/rightThrow/firstmitt/back/catchFace'
import { backAroundWeb } from 'src/features/dxm/drawer/rightThrow/firstmitt/back/backAroundWeb'
import { stitch } from 'src/features/dxm/drawer/rightThrow/firstmitt/back/stitch'
import { backOfIndexToLittle } from 'src/features/dxm/drawer/rightThrow/firstmitt/back/backOfIndexToLittle'
import { boomerang } from 'src/features/dxm/drawer/rightThrow/firstmitt/back/boomerang'
import { littleHook } from 'src/features/dxm/drawer/rightThrow/firstmitt/back/littleHook'
import { liningLeather } from 'src/features/dxm/drawer/rightThrow/firstmitt/back/liningLeather'
import { thumbHook } from 'src/features/dxm/drawer/rightThrow/firstmitt/back/thumbHook'
import { laces } from 'src/features/dxm/drawer/rightThrow/firstmitt/back/lace'
import { fingerGuardDrawer } from 'src/features/dxm/drawer/rightThrow/firstmitt/back/fingerGuardDrawer'
import { edgeDrawer } from 'src/features/dxm/drawer/rightThrow/firstmitt/back/edgeDrawer'
import { backOfThumbDrawer } from 'src/features/dxm/drawer/rightThrow/firstmitt/back/thumbDrawer'
import { wristBeltDrawer } from 'src/features/dxm/drawer/rightThrow/firstmitt/back/wristBeltDrawer'
import { notThumbEmbroidery, liningEmbroidery, thumbEmbroidery } from 'src/features/dxm/drawer/common/back/embroidery'
import { canvasResetter } from 'src/util/canvas'
import { loopOfRingFinger } from 'src/features/dxm/drawer/common/back/loopOfRingFinger'
import { dxmLabel } from '../../glove/back/label'

export const dxmCanvasFirstMittBack = (ctx: CanvasRenderingContext2D, state: State): void => {
  if (!state.boomerang) return
  if (!state.thumb) return
  if (!state.underWeb) return

  // リセット
  canvasResetter(ctx)
  // 裏革
  liningLeather(ctx, state.linings.color)
  const isEmbroideryOfLining = state.embroideries.some((x) => x.position.value === 'leatherLiningFirst')
  // 平裏への刺繍
  if (isEmbroideryOfLining) {
    liningEmbroidery(
      ctx,
      state.embroideries.find((e) => e.position.value === 'leatherLiningFirst'),
      110,
      -65
    )
  }

  const isEmbroideryOfLiningSecond = state.embroideries.some((x) => x.position.value === 'leatherLiningSecond')
  // 平裏への刺繍
  if (isEmbroideryOfLiningSecond) {
    liningEmbroidery(
      ctx,
      state.embroideries.find((e) => e.position.value === 'leatherLiningSecond'),
      110,
      -25
    )
  }

  loopOfRingFinger(ctx, state.loopOfRingFingerColor.color, state.stitch.color)

  // 捕球面
  catchFace(ctx, state.catchFace.color)
  // ウェブ先端側
  webTop(ctx, state.web.color, state.baseModel)
  // ウェブ捕球面側
  webBottom(ctx, state.web.color, state.baseModel)
  // ブーメラン部分
  boomerang(ctx, state.boomerang.color) // 専用のstateを設けて適用
  // 背面＿人差し指-小指
  backOfIndexToLittle(ctx, state.boomerang.color) // 専用のstateを設けて適用
  // 小指への刺繍
  const isEmbroideryOfChild = state.embroideries.some((x) => x.position.value === 'childFinger')
  if (isEmbroideryOfChild) {
    notThumbEmbroidery(
      ctx,
      state.embroideries.find((embroidery) => embroidery.position.value === 'childFinger'),
      30,
      -70
    )
  }

  // 背面＿親指_
  backOfThumbDrawer(ctx, state.thumb.color, state.stitch.color)
  // 手首ベルト
  wristBeltDrawer(ctx, state)

  // 小指掛け紐
  littleHook(ctx, state.littleHook.color)
  // 親指掛け紐
  thumbHook(ctx, state.thumbHook.color)
  // 親指への刺繍
  const isEmbroideryOfThumb = state.embroideries.some((x) => x.position.value === 'thumbFinger')
  if (isEmbroideryOfThumb) {
    thumbEmbroidery(
      ctx,
      state.embroideries.find((embroidery) => embroidery.position.value === 'thumbFinger'),
      -220,
      40,
      -20
    )
  }
  // 背面＿ウェブ周り
  backAroundWeb(ctx, state.underWeb.color)
  // ヘリ革
  edgeDrawer(ctx, state)
  // ステッチ
  stitch(ctx, state.stitch.color)
  // 指カバー
  fingerGuardDrawer(ctx, state.fingerGuardType.value, state.indexCover.color, state.stitch.color)

  // 刺繍
  dxmLabel(ctx, state, -50, -30, 0, 1.1)

  // 革紐
  laces(ctx, state.lace.color)
}
